import ajax from '../ajax';

async function fetchPartnerships() {
    const response = await ajax.get('admin/partnerships');
    return response.data;
}

export { fetchPartnerships };
